import { render, staticRenderFns } from "./CalendarEventEditor.vue?vue&type=template&id=6f5e9c0a&scoped=true&lang=pug&"
import script from "./CalendarEventEditor.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e9c0a",
  null
  
)

export default component.exports